// removed by extract-text-webpack-plugin
module.exports = {"playerIcon":"UKXjSZ2znT9v5KhJjrKJD","withSpectrum":"N8KDxPVk7kFk02196Zb7t"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TrackPlayPauseButton/TrackPlayPauseButton.scss
// module id = 1340
// module chunks = 1